import React from 'react';
import './Team.scss'; 
import Anchi from '../images/Anchi.jpeg';
import Jayden from '../images/Jayden.jpeg';

const Section = ({ imageSrc, title, description }) => (
  <div className="section">
    <div className="image">
      <img src={imageSrc} alt={title} />
    </div>
    <div className="text">
      <div className="title">
        <span>{title.split(':')[0]}</span>: {title.split(':')[1]}
      </div>
      <div className="description">{description}</div>
    </div>
  </div>
);

const Team = () => (
  <div className="container">
    <Section
      imageSrc={Anchi}
      title="Founder: Anchita Dutta"
      description="Hi everyone! I'm Anchita Dutta, founder of English Enclave. I'm a high school junior from Kolkata, India, with a passion for language, learning, and helping others. When I'm not geeking out over grammar, you can find me exploring makeup, fashion, tech, and psychology. I created English Enclave to empower individuals to unlock their full potential through language. Join me on this exciting journey and let's grow together!"
    />
    <Section
      imageSrc={Jayden}
      title="Co-Founder: Jayden Konki"
      description="Hey everyone! My name is Jayden Konki, and I am the proud co-founder of English Enclave. I’m currently a high school junior in Arizona, USA. Outside of managing school and this wonderful community, you can find me with one headphone in listening to a wide range of music, with a pencil in hand doing homework, or with a computer in front of me doing homework or pondering on my next venture! I hope to meet each and every one of you as an Enclavian in the near future."
    />
  </div>
);

export default Team;
